// The workspace session's persistence (2026-09-28): the ONE localStorage
// surface in the app. Two keys —
//   ciq.session  {slug, name, industryCode, code}  — the workspace a code
//                opened; cleared by logout. The code is kept so the app can
//                re-verify the session on load (a rotated or deleted code
//                logs the reader out on their next visit — a UI wall, not a
//                token scheme; see contexts/SessionContext).
//   ciq.device   a random id minted once per browser and NEVER cleared —
//                it feeds the server's distinct-devices count only, so a
//                re-login from the same laptop is the same device.
// Every read and write is wrapped: a private window, blocked site data or a
// preview can make the accessor throw or come back empty, and the app must
// render the wall in that case, not crash.
const SESSION_KEY = "ciq.session";
const DEVICE_KEY = "ciq.device";

const storage = () => {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch {
    return null;
  }
};

export function readSession() {
  try {
    const raw = storage()?.getItem(SESSION_KEY);
    const s = raw ? JSON.parse(raw) : null;
    return s && typeof s.slug === "string" && typeof s.code === "string"
      ? s
      : null;
  } catch {
    return null;
  }
}

export function writeSession(session) {
  try {
    storage()?.setItem(SESSION_KEY, JSON.stringify(session));
  } catch {
    /* storage unavailable — the session lives for this page load only */
  }
}

export function clearSession() {
  try {
    storage()?.removeItem(SESSION_KEY);
  } catch {
    /* nothing to clear */
  }
}

const newId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `d-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
};

// null when storage is unavailable — the server counts the login without a
// device then (device_id is optional on the wire)
export function deviceId() {
  try {
    const store = storage();
    if (!store) return null;
    let id = store.getItem(DEVICE_KEY);
    if (!id) {
      id = newId();
      store.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}
